import {
  fetchBaseQuery,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { logout, type RootState } from "..";
import { showToast, ToastType } from "../../utils/toast.utils";
import { ERROR_CODES, ErrorResponse } from "../../types";

export function createBaseQuery(
  baseUrl: string
): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> {
  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).session.user?.accessToken;

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  });

  return async (args, api, extraOptions) => {
    const result = await rawBaseQuery(args, api, extraOptions);
    if (result.error) {
      const { status, data } = result.error as ErrorResponse;

      if (data.code === ERROR_CODES.EXPIRED_TOKEN) {
        api.dispatch(logout());
        showToast(
          "Votre session est expirée, veuillez vous reconnecter",
          ToastType.INFO
        );
      } else if (status === 422) {
        showToast(
          "Certains champs sont invalides ou incomplets. Veuillez vérifier votre saisie.",
          ToastType.ERROR
        );
      } else if (status.toString().startsWith("4")) {
        showToast(data.message, ToastType.ERROR);
      } else {
        showToast(
          "Une erreur est survenue, veuillez réessayer.",
          ToastType.ERROR
        );
      }
    }

    return result;
  };
}
